import type { PartLogEntry, PartLogSource } from '@etnrlz/shared';
import { formatDateTime } from '../lib/format';

/** Cor/label por fonte do log (de onde veio a informação). */
export const partLogSourceMeta: Record<PartLogSource, { label: string; color: string }> = {
  MANUAL: { label: 'Manual', color: '#8a93a2' },
  EMAIL: { label: 'E-mail', color: '#60a5fa' },
  CORREIOS: { label: 'Correios', color: '#fbbf24' },
  FEDEX: { label: 'FedEx', color: '#a855f7' },
  UPS: { label: 'UPS', color: '#d97706' },
  DHL: { label: 'DHL', color: '#eab308' },
  INVOICE: { label: 'Invoice', color: '#34d399' },
  SISTEMA: { label: 'Sistema', color: '#8a93a2' },
};

export function LogSourceBadge({ fonte }: { fonte: PartLogSource }) {
  const m = partLogSourceMeta[fonte] ?? partLogSourceMeta.SISTEMA;
  return (
    <span
      className="text-[11px] px-1.5 py-0.5 rounded shrink-0 font-medium"
      style={{ color: m.color, background: `${m.color}1a` }}
    >
      {m.label}
    </span>
  );
}

export type LogEntryWithPart = PartLogEntry & { partTitulo?: string };

/** Lista de eventos do log (proveniência), mais recentes primeiro. */
export function PartLogList({ entries }: { entries: LogEntryWithPart[] }) {
  if (!entries.length) return <p className="text-sm text-muted">Sem registros ainda.</p>;
  const ordered = [...entries].sort((a, b) => (b.em ?? '').localeCompare(a.em ?? ''));
  return (
    <ul className="space-y-2.5">
      {ordered.map((e, i) => (
        <li key={i} className="flex gap-2.5">
          <div className="mt-1">
            <LogSourceBadge fonte={e.fonte} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-sm">{e.evento}</div>
            {e.detalhe && <div className="text-xs text-muted truncate">{e.detalhe}</div>}
            <div className="text-[11px] text-muted">
              {formatDateTime(e.em)}
              {e.partTitulo ? ` · ${e.partTitulo}` : ''}
              {e.por ? ` · ${e.por}` : ''}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
